import { render } from "./NavigationCard.vue?vue&type=template&id=18dbc04a"
import script from "./NavigationCard.vue?vue&type=script&lang=js"
export * from "./NavigationCard.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./NavigationCard.vue?vue&type=style&index=0&id=18dbc04a&lang=scss&module=true"
cssModules["$style"] = style0
script.render = render

export default script